<template>
  <div>
    <TableCompanyUsers />
    <ModalUserName />

    <UserTypeModal />

    <AddUserModal
      @update:show="(value) => (showAddUserModal = value)"
      :show="showAddUserModal"
      :for-company="parseInt(route.params.id)"
    />
    <UserReportsModal
      @update:show="(value) => (showUserReportsModal = value)"
      :show="showUserReportsModal"
      :user-id="selectedUserId"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import {
  defineComponent,
  ref,
  onMounted,
  onUnmounted
} from '@vue/composition-api'
import { createVuexHelpers } from 'vue2-helpers'
import { useRoute } from 'vue2-helpers/vue-router'

import { useDOMPageTitle } from '@composables'
import Members from '@services/Members'
import { UserTypeModal } from '@components/user'

import TableCompanyUsers from '@components/TableCompanyUsers'
import ModalUserName from '@components/ModalUserName'

import AddUserModal from '@components/AddUserModal'
import UserReportsModal from '@components/UserReportsModal'

export default defineComponent({
  name: 'ManageCompanyUsers',
  components: {
    TableCompanyUsers,
    UserTypeModal,
    ModalUserName,
    AddUserModal,
    UserReportsModal
  },
  setup() {
    const { setDOMPageTitle } = useDOMPageTitle()

    const { useGetters, useMutations } = createVuexHelpers()

    const { company } = useGetters(['company'])
    const { READ_MEMBER } = useMutations(['READ_MEMBER'])

    const route = useRoute()

    const showAddUserModal = ref(false)
    const showUserReportsModal = ref(false)
    const selectedUserId = ref(0)

    onMounted(() => {
      Vue.prototype.$bus.trackEvent('toggle-modal', async (payload) => {
        if (['user-report-access'].includes(payload.key)) {
          const resp = await Members.readMember(payload.id)
          const member = resp.data.data.data

          READ_MEMBER({
            data: member
          })
        }

        if ('add-user' === payload.key) {
          showAddUserModal.value = payload.active
        } else if ('user-report-access' === payload.key) {
          showUserReportsModal.value = payload.active

          selectedUserId.value = payload.id
        }
      })
    })

    onUnmounted(() => {
      Vue.prototype.$bus.destroyEvents()
    })

    setDOMPageTitle(company.value.name || '')

    return {
      route,
      showAddUserModal,
      showUserReportsModal,
      selectedUserId
    }
  }
})
</script>
